// extracted by mini-css-extract-plugin
module.exports = {"main":"_5DUSOQ5z","title":"_5D3VAouZ","content":"_5D1H4Qwo"};